



















































































































































































































































import {
  defineComponent,
  toRefs,
  computed,
  getCurrentInstance,
  ComponentInternalInstance,
  onMounted,
} from '@vue/composition-api';
import { CloseCircleFilledIcon, SearchIcon, LoadingIcon, DownloadIcon, EditIcon, CircleIcon } from 'tdesign-icons-vue';
import Chart from '@/renderer/components/charts/Chart.vue';
import EditSpace from '@/renderer/views/desktop/ManageConsole/Statistics/SpaceStatistics/components/editSpace.vue';
import { i18n_t } from '@/locales/i18n';
import { formatSize, getNameTipsDetail } from '@/renderer/scripts/utils/tools/index';
import ipc from '@/renderer/scripts/utils/ipc';
import { setResizableColumns } from '@/renderer/scripts/composition/tableResizeHandler';
import spaceHandler from './compositions/spaceHandler';
import listHandler from '../listHandler';
import { upgradeName, goUpgrade } from '../statisticsHandler';
export default defineComponent({
  components: {
    CloseCircleFilledIcon,
    SearchIcon,
    LoadingIcon,
    DownloadIcon,
    EditIcon,
    CircleIcon,
    Chart,
    EditSpace,
  },
  setup(props, context) {
    const currComponent = getCurrentInstance() as ComponentInternalInstance;
    const vm = currComponent.proxy;
    const store = context.root.$store;
    const orgSpaceInfo = computed(() => formatSize(store.getters.orgSpace));
    // 已使用容量
    const orgUsedInfo = computed(() => formatSize(store.getters.totalFileSize));
    // 剩余容量应为remainingSpaceQuota
    const resetInfo = computed(() => formatSize(`${store.getters.remainingSpaceQuota}`));
    // 剩余已分配容量 = 总容量 - 已使用量 - 剩余容量
    const orgAllocatedInfo = computed(() =>
      formatSize(+store.getters.orgSpace - +store.getters.totalFileSize - +store.getters.remainingSpaceQuota),
    );

    // 已使用 + 剩余已分配占比
    const percentArray = computed(() => {
      // 文件使用占比
      const usedPercent =
        store.getters.orgSpace === '0' ? 0 : +((store.getters.totalFileSize / store.getters.orgSpace) * 100).toFixed(2);
      // 剩余已分配额度使用占比
      const allocatedPercent =
        store.getters.orgSpace === '0'
          ? 0
          : +(
              ((+store.getters.orgSpace - +store.getters.totalFileSize - +store.getters.remainingSpaceQuota) /
                store.getters.orgSpace) *
              100
            ).toFixed(2);
      return [
        {
          percent: usedPercent,
          color: '#0444d9',
        },
        {
          percent: allocatedPercent,
          color: '#00b264',
        },
      ];
    });

    // 总使用占比
    const totalPercent = computed(() =>
      store.getters.orgSpace === '0'
        ? 0
        : +(((store.getters.orgSpace - store.getters.remainingSpaceQuota) / store.getters.orgSpace) * 100).toFixed(2),
    );

    const {
      teamSpaceSizeInfo,
      personalSpaceSizeInfo,
      chartLoading,
      chartOptions,
      methods: handlerMethods,
    } = spaceHandler();
    const {
      tabValue,
      columns,
      tableData,
      defaultSort,
      isExporting,
      showEditSpace,
      itemSpaceInfo,
      sort,
      methods: listMethods,
    } = listHandler('size');

    const resizeColumns = computed(() => setResizableColumns(columns.value));

    const placeholderText = computed(() =>
      tabValue.value === 'teamSpace'
        ? i18n_t('请输入团队名称搜索团队')
        : i18n_t('请输入用户昵称{slot1}搜索用户', {
            slot1: !store.getters.allowPhoneLogin ? '' : i18n_t('/手机号'),
          }),
    );

    const methods = {
      setCapacity({
        spaceType = 'teamSpace',
        id = -1,
        capacity,
      }: {
        spaceType: string;
        id: number;
        capacity: string | null;
      }) {
        if (spaceType === 'teamSpace') {
          listMethods.setTeamSapce(id, capacity);
        } else {
          listMethods.setPersonalSapce(id, capacity);
        }
      },
    };
    onMounted(() => {
      reporter.report('value_added', {
        space_show: 'management_center_value_button',
      });
      ipc.emit(ipc.RENDERER_EVENTS_MAP.START_ADMIN_GUIDE, false);
    });

    // 进入页面时更新一次企业空间总数、剩余数
    store.dispatch('GetOrgSpace');

    listMethods.pullList();
    handlerMethods.getSpaceStats();
    return {
      orgSpaceInfo,
      orgUsedInfo,
      orgAllocatedInfo,
      resetInfo,
      totalPercent,
      percentArray,
      upgradeName,
      sort,
      tabValue,
      resizeColumns,
      placeholderText,
      ...toRefs(tableData),
      defaultSort,
      isExporting,
      showEditSpace,
      itemSpaceInfo,
      teamSpaceSizeInfo,
      personalSpaceSizeInfo,
      chartLoading,
      chartOptions,
      goUpgrade,
      handlerMethods,
      listMethods,
      ...methods,
      getNameTipsDetail,
    };
  },
});
